(function () {
  var CONFIG_ID = "vetain-campaign-reservation-config";
  var STORAGE_VISITOR = "vetain_reservation_visitor_id";
  var STORAGE_PENDING = "vetain_pending_url"; // ← NEW: key written by password page

  var LUA_SCRIPT =
    "if redis.call('EXISTS', KEYS[1]) == 1 then return 'repeat' end " +
    "local n = redis.call('INCR', KEYS[2]) " +
    "if n > tonumber(ARGV[1]) then redis.call('DECR', KEYS[2]) return 'full' end " +
    "redis.call('SET', KEYS[1], '1', 'EX', tonumber(ARGV[2])) " +
    "return 'ok'";

  function readConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el || !el.textContent) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function uuid() {
    if (crypto && crypto.randomUUID) return crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getVisitorId() {
    try {
      var existing = localStorage.getItem(STORAGE_VISITOR);
      if (existing) return existing;
      var id = uuid();
      localStorage.setItem(STORAGE_VISITOR, id);
      return id;
    } catch (e) { return uuid(); }
  }

  function normalize(s) { return String(s || "").trim().toLowerCase(); }

  function cartRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return "/";
  }

  function upstashBaseUrl(url) { return String(url || "").trim().replace(/\/+$/, ""); }

  // ← CHANGED: now also checks localStorage as a fallback
  function getUrlParam(paramName) {
    // 1. Current URL query string
    var fromSearch = new URLSearchParams(window.location.search).get(paramName);
    if (fromSearch) return fromSearch;

    // 2. Current URL hash
    var hash = window.location.hash;
    if (hash && hash.length >= 2) {
      var hashContent = hash.charAt(0) === "#" ? hash.slice(1) : hash;
      if (hashContent.charAt(0) === "?") hashContent = hashContent.slice(1);
      if (hashContent) {
        var fromHash = new URLSearchParams(hashContent).get(paramName);
        if (fromHash) return fromHash;
      }
    }

    // 3. LocalStorage fallback — written by the password page snippet
    try {
      var raw = localStorage.getItem(STORAGE_PENDING);
      if (raw) {
        var stored = JSON.parse(raw);
        var TTL_MS = 60 * 60 * 1000; // must match password page snippet
        if (stored.ts && (Date.now() - stored.ts) < TTL_MS) {
          if (stored.search) {
            var s = new URLSearchParams(stored.search).get(paramName);
            if (s) return s;
          }
          if (stored.hash) {
            var hc = stored.hash.charAt(0) === "#" ? stored.hash.slice(1) : stored.hash;
            if (hc.charAt(0) === "?") hc = hc.slice(1);
            var h = new URLSearchParams(hc).get(paramName);
            if (h) return h;
          }
        }
      }
    } catch (e) { /* localStorage blocked */ }

    return null;
  }

  // ← NEW: call once the campaign has been consumed (or confirmed not applicable)
  function clearPendingUrl() {
    try { localStorage.removeItem(STORAGE_PENDING); } catch (e) { /* ignore */ }
  }

  function reserveSlot(cfg, visitorId, campaignId) {
    var base  = upstashBaseUrl(cfg.upstashUrl);
    var token = String(cfg.upstashToken || "").trim();
    if (!base || !token) return Promise.reject(new Error("config"));

    var vKey   = "reservation:" + campaignId + ":visitor:" + visitorId;
    var sKey   = "reservation:" + campaignId + ":slots";
    var maxUses = String(Math.max(1, parseInt(cfg.maxUses, 10) || 1));
    var ttl    = String(parseInt(cfg.visitorTtlSec, 10) || 7776000);
    var body   = JSON.stringify(["EVAL", LUA_SCRIPT, "2", vKey, sKey, maxUses, ttl]);

    return fetch(base, {
      method: "POST",
      headers: { Authorization: "Bearer " + token, "Content-Type": "application/json" },
      body: body,
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) return Promise.reject(data || new Error("upstash HTTP " + res.status));
        if (data && data.error) return Promise.reject(data.error);
        var result = data && data.result != null ? data.result : data;
        return String(result);
      });
    });
  }

  function applyDiscount(code) {
    return fetch(cartRoot() + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ discount: code }),
    }).then(function (res) {
      return res.json().then(function (cart) {
        if (!res.ok) return Promise.reject(cart || new Error("cart HTTP " + res.status));
        return cart;
      });
    });
  }

  function emitCartRefresh(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: cart } })
    );
  }

  function createBanner(messages) {
    var wrap = document.createElement("div");
    wrap.className = "vetain-campaign-banner";
    wrap.dataset.state = "loading";
    wrap.setAttribute("role", "status");
    wrap.setAttribute("aria-live", "polite");
    wrap.innerHTML =
      '<div class="vetain-campaign-banner__inner">' +
      '<div class="vetain-campaign-banner__glyph" aria-hidden="true">' +
      '<span class="vetain-campaign-banner__spinner"></span>' +
      '<span class="vetain-campaign-banner__symbol"></span>' +
      "</div>" +
      '<div class="vetain-campaign-banner__copy">' +
      '<p class="vetain-campaign-banner__title" hidden></p>' +
      '<p class="vetain-campaign-banner__text"></p>' +
      "</div>" +
      '<button type="button" class="vetain-campaign-banner__close" aria-label="' +
      escapeAttr(messages.dismiss) +
      '">&times;</button>' +
      "</div>";
    document.body.appendChild(wrap);
    var titleEl  = wrap.querySelector(".vetain-campaign-banner__title");
    var textEl   = wrap.querySelector(".vetain-campaign-banner__text");
    var closeBtn = wrap.querySelector(".vetain-campaign-banner__close");
    closeBtn.addEventListener("click", function () { wrap.remove(); });
    return {
      setPresentation: function (opts) {
        var o = opts || {};
        if (o.state) wrap.dataset.state = o.state;
        if (o.title) { titleEl.textContent = o.title; titleEl.hidden = false; }
        else { titleEl.textContent = ""; titleEl.hidden = true; }
        textEl.innerHTML = o.html != null ? o.html : "";
      },
      remove: function () { wrap.remove(); },
      el: wrap,
    };
  }

  function escapeAttr(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;");
  }

  function run() {
    var cfg = readConfig();
    if (!cfg || !cfg.campaignId) return;

    var messages   = cfg.messages || {};
    var paramName  = cfg.campaignParam || "campaign";
    var urlCampaign = getUrlParam(paramName);

    if (!urlCampaign) return;
    if (normalize(urlCampaign) !== normalize(cfg.campaignId)) return;

    clearPendingUrl(); // ← NEW: consumed — wipe it so it doesn't re-fire on the next page load

    var code         = String(cfg.discountCode || "").trim();
    var upstashUrl   = String(cfg.upstashUrl || "").trim();
    var upstashToken = String(cfg.upstashToken || "").trim();
    if (!code || !upstashUrl || !upstashToken) {
      var b0 = createBanner(messages);
      b0.setPresentation({ state: "error", title: messages.error_title || "", html: messages.error_config || "Configuration error." });
      return;
    }

    var banner = createBanner(messages);
    banner.setPresentation({ state: "loading", title: "", html: messages.loading || "…" });

    var visitorId  = getVisitorId();
    var campaignId = String(cfg.campaignId).trim();

    reserveSlot(cfg, visitorId, campaignId)
      .then(function (status) {
        if (status === "full") {
          banner.setPresentation({ state: "full", title: messages.exhausted_title || "", html: messages.exhausted || "" });
          return null;
        }
        var msgKey = status === "repeat" ? "success_repeat" : "success_new";
        return applyDiscount(code).then(function (cart) {
          emitCartRefresh(cart);
          banner.setPresentation({ state: "success", title: messages.success_title || "", html: messages[msgKey] || messages.success_new || "" });
          window.setTimeout(function () { banner.remove(); }, 6500);
          return cart;
        });
      })
      .catch(function () {
        banner.setPresentation({ state: "full", title: messages.exhausted_title || "", html: messages.exhausted || "" });
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();